import { Collapse, Divider, Paper } from "@material-ui/core";
import { observer } from "mobx-react";
import React from "react";
import { useStore } from "store/StoreConfigs";
import { batchDetailsStyles } from "./BatchDetailsStyles";
import { BatchDetailsProps } from "./BatchDetailsProps";
import ImpactAssessment from "components/ImpactAssessment/ImpactAssessment";
import BatchOverview from "components/BatchOverview/BatchOverview";
import ImpactDecision from "components/ImpactDecision/ImpactDecision";
import ReviewAssessment from "components/ReviewAssessment/ReviewAssessment";
import BatchHistoricalEvents from "components/BatchHistoricalEvents/BatchHistoricalEvents";
import ThorTemperatureChart from "components/ThorTemperatureChart/ThorTemperatureChart";
import BatchProductTemperatureRangesImpact from "components/BatchProductTemperatureRangesImpact/BatchProductTemperatureRangesImpact";

export default observer(function BatchDetails({ batch, isCollapseOpen }: BatchDetailsProps) {
    const classes = batchDetailsStyles();

    const { thorEventViewStore, identityStore } = useStore();

    return (
        <Collapse timeout={"auto"} in={isCollapseOpen} unmountOnExit className={classes.collapse}>
            <Paper className={classes.mainPaper} elevation={0}>
                <ThorTemperatureChart
                    temperatureItems={thorEventViewStore.deviceData.deviceData.map((x) => ({
                        ...x,
                        label: x.deviceName,
                        data: x.dataPoints.map((x2) => ({
                            x: x2.timestamp,
                            y: x2.value,
                        })),
                    }))}
                    isLoading={thorEventViewStore.isDeviceDataLoaded}
                    temperatureUpperLimit={thorEventViewStore.deviceData.temperatureUpperLimit}
                    temperatureLowerLimit={thorEventViewStore.deviceData.temperatureLowerLimit}
                />

                <BatchProductTemperatureRangesImpact {...batch} />

                <Divider className={classes.divider} />
                <BatchOverview batch={batch} />

                <Divider className={classes.divider} />
                <ImpactAssessment
                    highBandSummary={batch.highBandSummary}
                    lowBandSummary={batch.lowBandSummary}
                    batchId={batch.batchId}
                />
                <Divider className={classes.divider} />

                <ImpactDecision
                    assessmentStatusId={batch.assessmentStatusId}
                    batchId={batch.batchId}
                    decision={batch.details.decision}
                    quantity={batch.quantity}
                    isReturnedToStock={batch.isReturnedToStock}
                />
                {thorEventViewStore.eventDetails.reviewerUserId === identityStore.userInfo?.email && (
                    <ReviewAssessment
                        batchId={batch.batchId}
                        assessmentStatusId={batch.assessmentStatusId}
                        quantity={batch.quantity}
                        isReturnedToStock={batch.isReturnedToStock}
                    />
                )}
                <Divider className={classes.divider} />
                <BatchHistoricalEvents history={batch.history} />
            </Paper>
        </Collapse>
    );
});
